import {AddNoAccessList, DeleteNoAccessList, NoAccessList} from "../../axios/requests";
import Connections from "../../connections";
import {action, observable} from "mobx";
import {NoAccessDTO} from "../../screens/noAccessWheelScreen/NoAccessDTO/noAccess";
import {RequestStatus} from "../index";


export class NoAccessWheelStore {

    @observable noAccessList: NoAccessDTO[] = [];
    @observable noAccessCount = 0;
    @observable getNoAccessStatus = RequestStatus.IDLE;

    public async NoAccessWheelList(search: string, pageNumber: number, pageSize: number) {

        this.getNoAccessStatus = RequestStatus.LOADING;

        const response = await Connections.wadiDeglaAxios.httpGet(NoAccessList(
            pageNumber, pageSize, search,
        ));
        const {
            noAccessList,
            noAccessCount,
        } = response.data.data;
        this.noAccessCount = noAccessCount
        this.noAccessList = this.mapNoAccessList(noAccessList)
        this.getNoAccessStatus = RequestStatus.SUCCESS;
    }

    @action
    private mapNoAccessList(responseData: any): NoAccessDTO[] {
        return responseData.map((res: any) => ({
            membershipId: res.membership_id,
            id: res.id
        } as any));
    }

    public async AddNoAccessWheelList(listOfMembership: string) {

        try {
            const list = listOfMembership.split(/\r?\n/);
            if (list.length < 1)
                return {
                    status: false,
                    'message': 'Please Enter Valid List'
                }
            const response = await Connections.wadiDeglaAxios.httpPost(AddNoAccessList, {list});

            return {
                status: true,
                message: response.message
            }
        } catch (error) {

            console.error(error);
            return {
                status: false,
                'message': 'Please Enter Valid List'
            }
        }
    }

    public async RemoveNoAccessWheelMember(id: number) {

        try {
            this.getNoAccessStatus = RequestStatus.LOADING;
            const response = await Connections.wadiDeglaAxios.httpPost(DeleteNoAccessList, {id});
            this.getNoAccessStatus = RequestStatus.SUCCESS;

            return {
                status: true,
                message: response.message
            }
        } catch (error) {
            this.getNoAccessStatus = RequestStatus.FAILED;
            console.error(error);
            return {
                status: false,
                'message': 'Please Enter Valid List'
            }
        }
    }

}
